"use client";

import { useTranslations } from "next-intl";
import { useSpeiDetails } from "@/lib/queries/payment";
import { useCheckoutStore } from "@/lib/store/checkout";
import { ErrorBanner } from "./error-banner";
import { InstructionCard } from "./instruction-card";
import { InstructionContainer } from "./instruction-container";

export const SpeiInstructions = () => {
  const t = useTranslations("instructions");
  const { data, isPending, isError, refetch } = useSpeiDetails();
  const business = useCheckoutStore((s) => s.business);

  const renderDetails = () => {
    if (isError) return null;

    return (
      <>
        <InstructionCard
          title={t("spei.clabe")}
          value={data?.clabe}
          skeletonClassName="h-6 w-44 rounded-lg"
          loading={isPending}
          copyable
        />
        <InstructionCard
          title={t("spei.concept")}
          value={data?.order}
          skeletonClassName="h-6 w-32 rounded-lg"
          loading={isPending}
          copyable
        />
      </>
    );
  };

  return (
    <div className="space-y-8">
      {isError && <ErrorBanner refetch={refetch} />}
      <InstructionContainer isError={isError}>
        <p>{t("spei.intro")}</p>
        <div className="space-y-4">
          {renderDetails()}
          <InstructionCard
            title={t("spei.beneficiary")}
            value={business || "PayCode"}
            copyable
          />
          <InstructionCard title={t("spei.bank")} value="STP" copyable />
        </div>
        <p className="text-muted text-sm">
          {t.rich("help", {
            email: (chunks) => (
              <a className="text-accent" href="mailto:info@paycode.com.mx">
                {chunks}
              </a>
            ),
            phone: (chunks) => (
              <a className="text-accent" href="tel:+525624870068">
                {chunks}
              </a>
            ),
          })}
        </p>
      </InstructionContainer>
    </div>
  );
};
